import FJCoreConfig from '../FJCoreConfig';
class FontManager {
    constructor() {
        this.isLoadedFont = false;
        this.loadFontAsync(FJCoreConfig.fontFamily);
    }
    fontItems = () => {
        return [];
    };
    fontStyleDisableData = () => {
        return {
            disableBold: false,
            disableItalic: false,
        };
    };

    addFontStylesheetWithPath = path => {
        if (!path) return;

        let head = document.getElementsByTagName('head')[0];
        this._appendFontStyleLink(head, path);
    };

    _appendFontStyleLink = (parent, path) => {
        if (!parent) {
            return;
        }
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = path.replace(/\s/g, '-').toLowerCase();
        link.media = 'all';
        parent.appendChild(link);
    };

    loadFontAsync = async fontName => {
        if (this.isLoadedFont) {
            return;
        }
        const fontItem = {
            name: 'montserrat',
            image: 'montserrat.svg',
            css: 'montserrat.css',
            family: ['n4', 'i4', 'n7', 'i7'],
        };
        // 原本的字体
        let path = `https://resource.flexclip.com/app/resource/font/fonts/${fontItem.name}/${fontItem.css}`;
        this.addFontStylesheetWithPath(path);

        let fontStyle = fontItem.family;
        let family = ':';
        for (let i = 0; i < fontStyle.length; i++) {
            family += fontStyle[i];
            if (i !== fontStyle.length - 1) family += ',';
        }

        await this._loadFontAsync(fontName, family);
        this.isLoadedFont = true;
    };

    _loadFontAsync = async (fontName, family) => {
        const webFont = await import('webfontloader');
        await new Promise((resolve, reject) => {
            webFont.load({
                custom: {
                    families: [fontName + family],
                    fontName: fontName,
                    active: false,
                },
                loading: function () {},
                active: resolve,
                inactive: function () {
                    reject(new Error(`${fontName} load fail`));
                },
                timeout: 300000,
            });
        });
    };
}
let _instance = new FontManager();
export default _instance;
